module.exports = __webpack_public_path__ + "media/img/counsellors/valerie-075c6a6f7b1b961a06c28bccf9fc3b56.jpg";